import React, { useState } from 'react';
import '../../entrydoor.css';

const SillOptions = ({ value, onChange, label = 'Sill Options:', disabled = false }) => {
    const [selectedSillOptions, setSelectedSillOptions] = useState(value || "Standard");

    const handleSillOptionsChange = (e) => {
        setSelectedSillOptions(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="SillOptions">{label}</label>
            <select
                disabled={disabled}
                id="SillOptions"
                value={selectedSillOptions}
                onChange={handleSillOptionsChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Standard">{selectedSillOptions === "Standard" ? "Standard ✔" : "Standard"}</option>
                <option value="Handicap">{selectedSillOptions === "Handicap" ? "Low Sill (Handicap) ✔" : "Low Sill (Handicap)"}</option>

            </select>
        </div>
    );
};

export default SillOptions;
